module.exports = __webpack_public_path__ + "media/images/switch on-b9699e9b45b69c32e2dfb932382822df.svg";